import React from "react";
import { Avatar, Box, Stack, Typography } from "@mui/material";

export default function ConversationHeader({ partner, onOpenPerson }) {
  const openProfile = () => onOpenPerson?.();

  return (
    <Stack
      direction="row"
      spacing={1.5}
      alignItems="center"
      role="button"
      tabIndex={0}
      onClick={openProfile}
      onKeyDown={(event) => {
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          openProfile();
        }
      }}
      sx={{
        width: "fit-content",
        cursor: "pointer",
        borderRadius: "16px",
        "&:focus-visible": {
          outline: "2px solid rgba(23, 52, 93, 0.18)",
          outlineOffset: 4,
        },
      }}
    >
      <Avatar src={partner?.avatar || ""} sx={{ width: 44, height: 44 }}>
        {(partner?.username || "T").slice(0, 1).toUpperCase()}
      </Avatar>
      <Box>
        <Typography sx={{ fontWeight: 800, color: "#14213d", "&:hover": { color: "#17345d", textDecoration: "underline" } }}>
          {partner?.username || "Conversation"}
        </Typography>
        <Typography variant="body2" sx={{ color: "#718198" }}>
          Conversation
        </Typography>
      </Box>
    </Stack>
  );
}
